export const FRENCH_STOP_WORDS = new Set([
  'le',
  'la',
  'les',
  'de',
  'du',
  'des',
  'un',
  'une',
  'et',
  'a',
  'au',
  'aux',
  'en',
  'l',
  'd',
  'sarl',
  'sas',
  'sa',
  'eurl',
  'sasu',
  'ste',
  'soc',
])
